export const tapyblAiHomeText = {
  title: 'Hello',
  subtitle: 'Welcome back!',
  selection: 'What would you like to create?',
  aiAssistants: 'AI assistants',
  videos: 'Videos',
  courses: 'Courses',
  coursesDescription:
    'Create impactful courses tailored to your goals to inspire learning and empower your audience',
  aiAssistantsDescription:
    'Generate AI assistants from your content, accessible to learners across your workspace or within specific courses',
  aiVideosDescription:
    'Generate engaging videos aligned with your content to enhance learning and captivate your audience',
  microlessons: 'Microlessons',
  microlesosnsDescription:
    'Generate short, intuitive, microlessons outside of your courseware and instantly share with your learners',
};
